export default __webpack_public_path__ + "static/media/mighty-for-you-web.ad467190.svg";